import React from "react";
import { Offcanvas } from "react-bootstrap";
import { useTranslation } from "react-multi-lang";
import { useSelector } from "react-redux";

import StatusBadge from "./StatusBadge";
import { display } from "../Utility/Utility";

const ViewPayoutOffcanvas = ({ deposit, onHide }) => {
  const t = useTranslation("payout_transactions");
  const profile = useSelector((state) => state.admin.profile);

  if (!deposit) return null;

  const {
    order_id,
    amount_formatted,
    utr_number,
    payment_picture,
    created_at,
    updated_at,
    status_formatted,
    opening_balance,
    closing_balance
  } = deposit || {};

  const {
    account_holder_name,
    account_number,
    ifsc_code,
    bank_name
  } = deposit?.payout_bank || {};

  const showLedger = profile?.data?.show_payout_ledger && (status_formatted || "").toUpperCase() === "COMPLETED";

  return (
    <Offcanvas show={!!deposit} onHide={onHide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{t("heading")}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <div className="view-modal-wrap">

          {/* PAYMENT ID */}
          <div className="view-modal-card-wrap">
            <div className="view-modal-card">
              <div>{t("settlement_table.payment_id")}</div>
              <div>{display(order_id)}</div>
            </div>

            <div className="view-modal-card">
              <div>{t("amount")}</div>
              <div className="transaction-amount">{display(amount_formatted)}</div>
            </div>

            <div className="view-modal-card">
              <div>{t("utrNumber")}</div>
              <div className="">{display(utr_number)}</div>
            </div>
          </div>

          {/* BANK DETAILS */}
          <div className="view-modal-card-wrap">
          <div className="view-modal-card">
              <div>{t("beneficiaryAccount.bank")}</div>
              <div>{display(bank_name)}</div>
            </div>

            <div className="view-modal-card">
              <div>{t("beneficiaryName.name")}</div>
              <div>{display(account_holder_name)}</div>
            </div>

            <div className="view-modal-card">
              <div>{t("beneficiaryIFSC.name")}</div>
              <div>{display(ifsc_code)}</div>
            </div>

            <div className="view-modal-card">
              <div>{t("beneficiaryAccount.name")}</div>
              <div>{display(account_number)}</div>
            </div>
          </div>

          {/* PAYOUT LEDGER (IF COMPLETED) */}
            {showLedger == 1 && (
              <div className="view-modal-card-wrap">
                <div className="view-modal-card">
                  <div>{t("opening_balance")}</div>
                  <div>{display(opening_balance)}</div>
                </div>
  
                <div className="view-modal-card">
                  <div>{t("closing_balance")}</div>
                  <div>{display(closing_balance)}</div>
                </div>
              </div>
            )}

          {/* PAYMENT PICTURE (IF EXISTS) */}
          {payment_picture && (
            <div className="view-modal-card">
              <div>{t("payment_picture")}</div>
              <div>
                <a href={payment_picture} target="_blank" rel="noreferrer">
                  {t("view")}
                </a>
              </div>
            </div>
          )}

          {/* STATUS */}
          <div className="view-modal-card">
            <div>{t("status")}</div>
            <StatusBadge status={status_formatted} />
          </div>

          {/* DATES */}
          <div className="view-modal-card">
            <div>{t("requested_date")}</div>
            <div>{display(created_at)}</div>
          </div>

          <div className="view-modal-card">
            <div>{t("last_updated_date")}</div>
            <div>{display(updated_at)}</div>
          </div>

        </div>
      </Offcanvas.Body>

    </Offcanvas>
  );
};

export default ViewPayoutOffcanvas;
